﻿window["initMap"] = require("./googlemaps.js").initMap;

export function initMap() {
    if (!$("._js-google-maps").length) {
        return;
    }
    var $el = $("._js-google-maps");

    $el.each(function(i, el) {
        var lat = $(el).data("lat");
        var lon = $(el).data("lon");

        var myLatLng = {
            lat: lat,
            lng: lon
        };

        var map = new google.maps.Map(el, {
            zoom: 12,
            center: myLatLng
        });

        var marker = new google.maps.Marker({
            position: myLatLng,
            map: map
        });
    });
}
export default initMap;